import { validDownSellLicense } from '@/utils/validate-downsell';

export default {
  data() {
    return {
      mx_downSellLicenseErrorMessage: '',
    };
  },
  methods: {
    mx_validDownSellLicense(license) {
      if (this.$context.is.editPage) {
        const { errorMessage } = validDownSellLicense({ quantity: license });
        this.mx_downSellLicenseErrorMessage = errorMessage;
      }
    },
  },
};
